import React from "react";

export const Section = ({ id, num, eyebrow, title, lede, children }) => (
  <section className="section" id={id} data-testid={`section-${id}`}>
    <div className="eyebrow"><span className="num">{String(num).padStart(2, "0")}</span>{eyebrow || "Section"}</div>
    <h2>{title}</h2>
    {lede && <p className="lede">{lede}</p>}
    {children}
  </section>
);

export const H3 = ({ children }) => <div className="h3">{children}</div>;

export const Bullets = ({ items, gold }) => (
  <ul className={`bullets ${gold ? "gold" : ""}`}>
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);

export const Stat = ({ num, label, src, variant }) => (
  <div className={`stat ${variant || ""}`}>
    <div className="stat-num">{num}</div>
    <div className="stat-label">{label}</div>
    {src && <div className="stat-src">{src}</div>}
  </div>
);

export const StatGrid = ({ children }) => <div className="stat-grid">{children}</div>;

export const Callout = ({ variant, title, children }) => (
  <div className={`callout ${variant || ""}`}>
    {title && <div className="callout-title">{title}</div>}
    <p>{children}</p>
  </div>
);

export const Pull = ({ children }) => <div className="pull">{children}</div>;

export const Table = ({ head, rows }) => (
  <div className="tbl-wrap">
    <table className="tbl">
      <thead><tr>{head.map((h, i) => <th key={i}>{h}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>{r.map((c, j) => <td key={j} dangerouslySetInnerHTML={{ __html: c }} />)}</tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Figure = ({ title, tag, caption, children }) => (
  <div className="figure">
    <div className="fig-head">
      <div className="fig-title">{title}</div>
      {tag && <div className="fig-tag">{tag}</div>}
    </div>
    {children}
    {caption && <div className="fig-cap">{caption}</div>}
  </div>
);

export const Card = ({ icon, title, children }) => (
  <div className="card">
    <div className="ct">{icon}{title}</div>
    <p>{children}</p>
  </div>
);
